// src/components/Sidebar.js
import { useState } from "react";
import {
  FiCalendar,
  FiClipboard,
  FiCreditCard,
  FiHelpCircle,
  FiHome,
  FiMenu,
  FiUnlock,
  FiUser,
  FiX,
} from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/logos/newLogo.png";

const Sidebar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: "Home", path: "dashboard", icon: FiHome },
    { label: "Book an Appointment", path: "appointments", icon: FiCalendar },
    { label: "Assessment Results", path: "assessments", icon: FiClipboard },
    { label: "Profile Settings", path: "profile", icon: FiUser },
    { label: "Help and Support", path: "help", icon: FiHelpCircle },
    { label: "Billing and Payments", path: "billing", icon: FiCreditCard },
    { label: "Logout", path: "logout", icon: FiUnlock },
  ];

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative">
      <div className="md:hidden px-6 pt-2 w-screen flex items-center">
        <button className="text-gray-700" onClick={toggleSidebar}>
          {isOpen ? (
            <FiX className="w-6 h-6" />
          ) : (
            <FiMenu className="w-6 h-6" />
          )}
        </button>
        <img
          src={Logo}
          width={"40%"}
          className="m-auto object-cover"
          alt="Logo"
        />
      </div>
      <div
        className={`fixed inset-y-0 left-0 w-72 md:w-full z-50 h-screen bg-white shadow-lg overflow-hidden transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out md:relative md:translate-x-0`}
      >
        <div className="p-4">
          <button className="text-gray-700 md:hidden" onClick={toggleSidebar}>
            {isOpen ? (
              <FiX className="w-6 h-6" />
            ) : (
              <FiMenu className="w-6 h-6" />
            )}
          </button>
          <div className="w-full py-2 flex items-center justify-center">
            <img src={Logo} width={80} className="w-1/2" alt="Logo" />
          </div>
          <div className="border-t border-gray-300 my-6"></div>
          <ul className="space-y-4">
            {menuItems.map((item) => {
              return (
                <li key={item.path}>
                  <Link
                    to={item.path === "dashboard" ? "" : item.path}
                    className={`flex items-center p-2 text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-primary group  ${
                      location.pathname === "dashboard"
                        ? "bg-primary text-white"
                        : location.pathname.endsWith(item.path)
                        ? "bg-primary text-white"
                        : "text-gray-800"
                    }`}
                    onClick={() => (isOpen ? setIsOpen(false) : null)}
                  >
                    <item.icon
                      className={`w-5 h-5 mr-2  hover:text-white ${
                        location.pathname === "dashboard"
                          ? "bg-primary text-white"
                          : location.pathname.endsWith(item.path)
                          ? "bg-primary text-white"
                          : "text-gray-800"
                      }`}
                      color={
                        location.pathname === "dashboard"
                          ? "white"
                          : location.pathname.endsWith(item.path)
                          ? "white"
                          : "black"
                      }
                    />

                    <span
                      className={`mx-2 flex-1 ms-3 whitespace-nowrap hover:text-white text-black hover:text-white${
                        location.pathname === "dashboard"
                          ? "bg-primary text-white"
                          : location.pathname.endsWith(item.path)
                          ? "bg-primary text-white"
                          : "text-gray-800"
                      }`}
                    >
                      {item.label}
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default Sidebar;
